import SchoolInformationTab from '../components/schoolInformationTab';
import UsersTab from '../components/usersTab';

import { TrashCanIcon } from '../../core/customIcons';


export const getDetailViewConfig = async () => {
    return {
        titleConfig: {
            breadcrumbs: true,
            field: 'name',
            mainAction: {
                type: 'text',
                text: 'Delete This School',
                field: 'delete',
                textColor: 'warning.main',
                textStyles: ["underline"],
                preIcon: <TrashCanIcon />,
                modalConfig: {
                    delete: {
                        title: 'Delete School',
                        type: 'text',
                        message: 'Are you sure you want to delete {data.name} school?',
                        submitLabel: 'Delete',
                        cancelLabel: 'Cancel',
                        submitColor: 'red',
                        cancelColor: 'blue',
                        submitType: 'delete',
                    }
                }
            },
        },
        title: 'schools',
        type: 'schools',
        tabs: [
            {title: 'School Information', component:SchoolInformationTab},
            {title: 'Users', component:UsersTab},
        ],
        actions: {
            edit: false,
            delete: false
        }
    }
}